// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.photos.RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AttestDigitallyAlteredPhotosRequestDto,
  DigitallyAlteredPhotosDetailsWebResponseDto,
  ListingAlias,
  RemoveOriginalDigitallyAlteredPhotoRequestDto,
  SetDigitallyAlteredPhotoRequestDto,
  UploadOriginalDigitallyAlteredPhotoRequestDto,
} from '../..';

interface DetailsParams {
  listingAlias: ListingAlias;
}
interface UploadParams {
  photoId: string;
}

export const RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_attest_Path =
  '/api/web/v1/users/properties/photos/digitallyAltered/attest';

/**
 * Record that the user will mark digitally altered photos on a listing
 */
export const RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_attest = (
  postData: AttestDigitallyAlteredPhotosRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, AttestDigitallyAlteredPhotosRequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_attest_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details_Path =
  '/api/web/v1/users/properties/photos/digitallyAltered/details';

/**
 * Get whether digitally altered photos apply to a listing and if the attestation is done
 */
export const RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details = (
  getParams: DetailsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DetailsParams, never, DigitallyAlteredPhotosDetailsWebResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_remove_Path =
  '/api/web/v1/users/properties/photos/digitallyAltered/original/remove';

/**
 * Remove the unaltered original of a property photo
 */
export const RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_remove = (
  postData: RemoveOriginalDigitallyAlteredPhotoRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RemoveOriginalDigitallyAlteredPhotoRequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_remove_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_set_Path =
  '/api/web/v1/users/properties/photos/digitallyAltered/set';

/**
 * Mark a property photo as digitally altered or not; unmarking clears its original photo
 */
export const RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_set = (
  postData: SetDigitallyAlteredPhotoRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SetDigitallyAlteredPhotoRequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_set_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_upload_Path =
  '/api/web/v1/users/properties/photos/digitallyAltered/original/upload';

/**
 * Upload the unaltered original of a property photo marked digitally altered
 */
export const RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_upload = (
  getParams: UploadParams,
  postData: UploadOriginalDigitallyAlteredPhotoRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<UploadParams, UploadOriginalDigitallyAlteredPhotoRequestDto, string>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_upload_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
      isFormData: true,
    },
    client,
  );
};
